import { CapoPlugin } from "/home/runner/work/ticketco-tickets/ticketco-tickets/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];